const messages = {
  title: 'Greška prekoračenja vremena pristupa',
  description: 'Izvinjavamo se zbog neprijatnosti. Izgleda da naš server nekako nije primio pravovremeni odgovor.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
